import Pointer from "poin"
import * as Objdict from "objdict"
import Speedtest from "@frog/source/tests/utility/Speedtest.js"
import Keyb from "keyb"
import Stage from "@frog/source/models/Stage.js"
import Geometry from "@frog/source/utility/Geometry.js"
import clipboard from "copy-to-clipboard"
import Director from "@frog/source/juice/Director.js"
import World from "@frog/source/models/World.js"
import Zone from "@frog/source/models/Zone.js"
import App from "@frog/source/models/App.js"
import {getTime} from "@frog/source/juice/utility/Time.js"

const MINIMUM_SELECTION_DURATION = 250 // in milliseconds.
const MAXIMUM_HOVERED_POSITIONS = 10

import Audiomix from "@frog/source/juice/Audiomix.js"

import sizes from "@frog/source/data/sizes.js"

import Canvas from "@frog/source/utility/canvas/index.js"

function calculateRelativePosition({x, y}, dom) {
    if(dom == undefined) return {"x": 0, "y": 0}
    const bounds = dom.getBoundingClientRect()
    x = ((x - bounds.left) / bounds.width) * sizes.canvas.width
    y = ((y - bounds.top) / bounds.height) * sizes.canvas.height

    return {x, y}
}

function accountForCamera({x, y}, camera) {
    x += camera.position.x
    y += camera.position.y
    return {x, y}
}

function convertCartesianToIsometric({x, y}) {
    const isoposition = {
        "x": ((x / (sizes.grid.width / 2)) + (y / (sizes.grid.height / 2))) / 2,
        "y": ((y / (sizes.grid.height / 2)) - (x / (sizes.grid.width / 2))) / 2,
    }
    // isoposition.x += 1 // because why??
    // isoposition.y += 1 // because why??
    isoposition.x += 0.5
    isoposition.y += 0.5 // i'm doing 0.5 now because the depth of each block is 0 in this project??
    isoposition.z = 0
    return isoposition
}

function convertCartesianToTiledCoordinates(position) {
    position.x /= sizes.grid.width
    position.y /= sizes.grid.height
    position.x += sizes.defaultAnchor.x
    position.y += sizes.defaultAnchor.y // HOLD UP IS THIS DOING ANYTHING?? THIS REQUIRES THE ANCHOR TO BE 0.5 & 1, not "50%" & "100%"
    position.x = Math.floor(position.x)
    position.y = Math.floor(position.y)
    position.z = 1
    return position
}

function squareup({x, y}) {
    return {
        // "x": Math.floor(x),
        // "y": Math.floor(y),
        "x": Math.round(x),
        "y": Math.round(y),
    }
}

// const GOLDEN_RATIO = 1.618
// const BLOCK_HEIGHT = 1 / GOLDEN_RATIO // ~0.618
// const BLOCK_HEIGHT = sizes.grid.depth / sizes.grid.height // 0.875
// const BLOCK_HEIGHT = sizes.grid.height / sizes.grid.depth // 1.142
const BLOCK_HEIGHT = 0.95 // Not sure how to get this magical number. I just fudged it until the cursor lit up good.
// i still think depth / height is most correct (0.875), but our tiles are a little taller than they are along the grid.
// const BLOCK_HEIGHT = 1

function raycast(stage, position) {
    let castposition = position
    Objdict.forEach(stage.world.terrain, (terrain) => {
        // if(terrain.position.z == 0) {
        //     return
        // }
        const superposition = {
            "x": Math.floor(position.x + ((terrain.size.z) * BLOCK_HEIGHT)),
            "y": Math.floor(position.y + ((terrain.size.z) * BLOCK_HEIGHT)),
            "z": terrain.size.z // assuming position.z should be... zero? so we don't add it
        }
        if(superposition.x == terrain.position.x
        && superposition.y == terrain.position.y) {
            castposition = superposition
        }
    })
    return castposition
}

export default class Selection {
    constructor(that) {
        this.encounter = that.encounter

        this.selectedUnitKey = undefined
        this.hoveredUnitKey = undefined
        this.hoveredAction = undefined

        this.position = {"x": 0, "y": 0}
        this.previousPositions = []

        this.camera = {
            "type": sizes.camera.type,
            "position": sizes.camera.position || {
                // "x": -1 * sizes.grid.width * sizes.defaultAnchor.x, // + 8,
                // "y": -1 * sizes.grid.height * sizes.defaultAnchor.y // + 16,
                // "x": 0,
                // "y": 0,
            }
        }

        this.watchedUnits = {}
    }
    update(delta) {

        if(Pointer.isIgnoringForFrame != undefined
        && Pointer.isIgnoringForFrame > 0) {
            Pointer.isIgnoringForFrame -= 1
        }

        let isInDialogue = App.getActiveStage().dialogue != undefined
        if(isInDialogue) {
            this.position = {"x": -100, "y": -100, "z": 0}
            this.unselect()
            return
        }

        if(this.camera.type == "isometric") {
            this.position = Pointer.position
            this.position = calculateRelativePosition(this.position, Canvas.dom)
            this.position = accountForCamera(this.position, this.camera)
            this.positionBeforeProjection = this.position
            this.position = convertCartesianToIsometric(this.position)
            // this.position = raycast(this.encounter.stage, this.position)
            this.position = squareup(this.position)
            this.position.z = 1 // TODO: ACTUALLY RAYCAST INSTEAD!!
        } else if(this.camera.type == "top-down") {
            this.position = Pointer.position
            this.position = calculateRelativePosition(this.position, Canvas.dom)
            this.position = accountForCamera(this.position, this.camera)
            this.position = convertCartesianToTiledCoordinates(this.position)
        }

        if(Zone.isInBounds(this.encounter.stage.encounters[this.encounter.stage.currentEncounter || 1].zone, this.position)
        && World.isOutOfBounds(this.encounter.stage.world, this.position) == false) {
            let isNewlyHovered = false
            if(this.previousPositions[0] == undefined
            || this.previousPositions[0].x != this.position.x
            || this.previousPositions[0].y != this.position.y) {
                this.previousPositions.unshift({"x": this.position.x, "y": this.position.y, "z": this.position.z})
                if(this.previousPositions.length > MAXIMUM_HOVERED_POSITIONS) {
                    this.previousPositions.pop()
                }
                isNewlyHovered = true
                this.hoveredTime = getTime().ms
            }

            this.hoveredUnitKey = (Stage.findUnitByPosition(this.encounter.stage, this.position) || {}).key

            if(this.canAction(this.selectedUnitKey, this.encounter.stage)) {
                this.hoveredAction = this.findAction({
                    "unit": this.selectedUnit,
                    "position": this.position
                })
            } else {
                this.hoveredAction = undefined
            }

            // // DEBUG
            if(this.hoveredAction != undefined
            && this.hoveredAction.omegastage.nextTurn == undefined) {
                const mark = Speedtest.mark("Actions", "Selection.update")
                // Stage.calculateNextTurn(this.hoveredAction.omegastage)
                // Stage.calculateNextTurn(this.hoveredAction.omegastage, {"ignoreAI": true})
                mark()//.log({"maximum": 100})
            }

            if(Pointer.isIgnoringForFrame == undefined
            || Pointer.isIgnoringForFrame <= 0) {
                if(Pointer.wasJustPressed("primary", true, delta.ms)) {
                    this.start()
                }
                if(Pointer.wasJustPressed("primary", false, delta.ms)) {
                    this.finish()
                }
                if(Keyb.wasJustPressed("<escape>", delta.ms)
                || Pointer.wasJustPressed("secondary", true, delta.ms)) {
                    this.cancel()
                }
            }

            if(isNewlyHovered == true) {
                Audiomix.trigger("Selection:Move")
                // if(this.selectedUnitKey != undefined
                // && this.hoveredAction != undefined) {
                //     Audiomix.trigger("Selection:Move")
                // } else if(this.hoveredUnitKey != undefined) {
                //     Audiomix.trigger("Selection:Move")
                // }
            }
        }

        // DEBUG???
        if(Pointer.wasJustPressed("auxiliary", true, delta.ms)) {
            const position = this.position.x + "x" + this.position.y
            clipboard(position)
            console.log(">", position)
        }

        if(Pointer.wasJustPressed("primary", true, delta.ms)) {
            if(this.encounter.stage.units[this.hoveredUnitKey] != undefined
            && this.encounter.stage.units[this.hoveredUnitKey].affiliation == "bad") {
                this.watchedUnits[this.hoveredUnitKey] = !this.watchedUnits[this.hoveredUnitKey]
            }
        }

        if(this.selectedUnit != undefined
        && this.selectedUnit.equippedSkills != undefined) {
            Object.values(this.selectedUnit.equippedSkills).forEach((skillKey, index) => {
                if(Keyb.wasJustPressed(index + 1)) {
                    this.selectedSkillKey = skillKey
                }
            })
        }

        // if(Keyb.isDown("W") || Keyb.isDown("<up>")) {
        //     this.camera.position.y -= 1
        // }
        // if(Keyb.isDown("S") || Keyb.isDown("<down>")) {
        //     this.camera.position.y += 1
        // }
        // if(Keyb.isDown("A") || Keyb.isDown("<left>")) {
        //     this.camera.position.x -= 1
        // }
        // if(Keyb.isDown("D") || Keyb.isDown("<right>")) {
        //     this.camera.position.x += 1
        // }

        const stage = stage || App.getActiveStage() // IS THIS WEIRD? YeAH IT'S WEIRD
        const currentZone = stage.encounters[stage.currentEncounter || 1].zone
        if(currentZone != undefined) {
            const zone = {}
            zone.x = currentZone.x * sizes.grid.width
            zone.y = currentZone.y * sizes.grid.height
            zone.x -= sizes.grid.width * sizes.defaultAnchor.x
            zone.y -= sizes.grid.height * sizes.defaultAnchor.y

            zone.width = currentZone.width * sizes.grid.width
            zone.height = currentZone.height * sizes.grid.height

            if(sizes.canvas.width > zone.width
            && sizes.canvas.height > zone.height) {
                zone.x -= (sizes.canvas.width - zone.width) / 2
                zone.y -= (sizes.canvas.height - zone.height) / 2
            }

            // const CAMERA_SPEED = 0.1
            // const CAMERA_AXES = ["x", "y"]
            // CAMERA_AXES.forEach((axis) => {
            //     this.camera.position[axis] += (zone[axis] - this.camera.position[axis]) * CAMERA_SPEED
            //     if(Math.abs(zone[axis] - this.camera.position[axis]) < 1) {
            //         this.camera.position[axis] = zone[axis]
            //     }
            // })
        }
    }
    select(unitKey) {
        this.selectedUnitKey = unitKey
        this.selectedTime = getTime().ms
        this.selectedSkillKey = undefined

        if(window.tutorial == 0) {
            window.tutorial += 1
        }
    }
    unselect() {
        this.selectedUnitKey = undefined
        this.selectedTime = undefined
        this.selectedSkillKey = undefined
    }
    reset() {
        this.unselect()
    }
    start() {
        if(this.selectedUnitKey == undefined) {
            if(this.canSelect(this.hoveredUnitKey)) {
                this.select(this.hoveredUnitKey)
                Audiomix.trigger("Selection:Start")
                // console.log("START")
            }
        } else if(this.selectedUnitKey != undefined) {
            if(this.hoveredAction != undefined
            && Action.isNothing(this.hoveredAction) != true) {
                return
            }
            // You click on another selectable unit, you select
            // that unit instead. Note that this is blocked by
            // action tiles, so it'd rather invoke a selected
            // skill on that unit rather than select it.
            if(this.hoveredUnitKey != undefined
            && this.hoveredUnitKey != this.selectedUnitKey
            && this.canSelect(this.hoveredUnitKey)
            && this.hoveredUnit.affiliation != "bad") {
                // During the prepare phase, selecting
                // another unit while you have another
                // already selected swaps their positions.
                if(this.encounter.phase == "prepare") {
                    if(this.selectedUnit.type == "plant" || this.hoveredUnit.type == "plant") {
                        return
                    }
                    const hoveredPosition = this.hoveredUnit.position
                    this.hoveredUnit.position = this.selectedUnit.position
                    this.selectedUnit.position = hoveredPosition
                }
                // console.log("RESTART TYPE 1")
                this.select(this.hoveredUnitKey)
                Audiomix.trigger("Selection:Start")
                return
            }
        }
    }
    finish() {
        if(this.selectedUnitKey != undefined
        && getTime().ms - this.selectedTime >= MINIMUM_SELECTION_DURATION) {
            if(this.encounter.phase == "prepare") { // FROM APOCALYPSE
                if(World.isEmptyPosition(this.encounter.stage.world, this.position)) {
                    return
                }
                if(this.selectedUnit.type == "plant"
                && this.encounter.stage.world.blocks[this.position.x + "x" + this.position.y + "x" + 0] != undefined
                && this.encounter.stage.world.blocks[this.position.x + "x" + this.position.y + "x" + 0].type != "plot") {
                    return
                }
                const collidingUnit = Stage.findUnitByPosition(this.encounter.stage, this.position)
                if(collidingUnit != undefined
                && collidingUnit.affiliation == "bad") {
                    return
                }
                if(collidingUnit != undefined
                && collidingUnit.type == "plant"
                && collidingUnit.key != this.selectedUnit.key) {
                    return
                }

                this.selectedUnit.position = this.position
                this.unselect()
                // console.log("FINISH: WITH PREP")
                return
                // TODO: Do we need to recalculate anything here??
            }
            // // You click on a unit to select it, you click on a unit
            // // again to unselect it. This is important for mobile.
            // if(this.selectedUnitKey == this.hoveredUnitKey) {
            //     // console.log("CANCEL: ON SELF")
            //     this.selectedUnitKey = undefined
            //     this.selectedTime = undefined
            //     Audiomix.trigger("Selection:Cancel")
            //     return
            // }
            // You click on an action tile, you perform that action.
            if(this.hoveredAction != undefined
            && Action.isNothing(this.hoveredAction) != true) {
                const hoveredAction = this.hoveredAction

                this.hoveredAction = undefined
                if(this.canSelect(this.selectedUnitKey, omegastage) == false) {
                    this.selectedSkillKey = undefined
                    // console.log("CANCEL: NO FURTHER ACTIONS")
                    this.unselect()
                }
                this.selectedSkillKey = undefined
                // console.log("FINISH")
                // console.log("Selected Action", this.hoveredAction)
                const omegastage = this.encounter.performAction(hoveredAction)

                Audiomix.trigger("Selection:Finish")
                return
            }
            // You click on another selectable unit, you select
            // that unit instead. Note that this is blocked by
            // action tiles, so it'd rather invoke a selected
            // skill on that unit rather than select it.
            if(this.hoveredUnitKey != undefined
            && this.canSelect(this.hoveredUnitKey)) {
                // console.log("RESTART TYPE 2")
                this.hoveredAction = undefined
                this.select(this.hoveredUnitKey)
                Audiomix.trigger("Selection:Start")
                return
            }
            // You click where there are no units or
            // action tiles, you unselect the unit.
            if(this.hoveredAction == undefined
            || Action.isNothing(this.hoveredAction) == true) {
                // console.log("CANCEL: ON NOTHING")
                this.hoveredAction = undefined
                this.unselect()
                Audiomix.trigger("Selection:Cancel")
            }
        }
    }
    cancel() {
        if(this.selectedSkillKey != undefined) {
            this.hoveredAction = undefined
            this.selectedSkillKey = undefined
            Audiomix.trigger("Selection:Cancel")
        } else if(this.selectedUnitKey != undefined) {
            this.hoveredAction = undefined
            this.unselect()
            Audiomix.trigger("Selection:Cancel")
        }
    }
    isSelected(unit) {
        return unit != undefined
            && this.selectedUnitKey == unit.key
    }
    canSelect(unitKey, stage) {
        stage = stage || this.encounter.stage
        const unit = stage.units[unitKey]
        if(unitKey == undefined
        || unit == undefined) {
            return false
        }
        if(this.encounter.phase == "prepare") {
            if(unit.affiliation == "bad") {
                return false
            }
            if(unit.class == "kiwisquash") {
                return false
            }
        }
        return unitKey != undefined
            && unit != undefined
            && unit.isDead != true
            && unit.type != "zone"
            // && unit.affiliation == this.encounter.player.affiliation
    }
    canAction(unitKey, stage) {
        stage = stage || this.encounter.stage
        const unit = stage.units[unitKey]
        return unitKey != undefined
            && unit != undefined
            && unit.affiliation == this.encounter.player.affiliation
    }
    canSelectUnitSkill(unit, skill) {
        return unit != undefined
            && unit.energy["invoke skill"] == true
    }
    get selectedUnit() {
        return this.encounter.stage.units[this.selectedUnitKey]
    }
    get hoveredUnit() {
        return this.encounter.stage.units[this.hoveredUnitKey]
    }
    get activeUnitKey() {
        return this.hoveredUnitKey || this.selectedUnitKey
    }
    get activeUnit() {
        return this.selectedUnit || this.hoveredUnit
    }
    get activeSkillKey() {
        return this.hoveredSkillKey || this.selectedSkillKey
    }
    mode(unit) {
        if(unit == undefined) {
            return "none"
        }
        if(this.activeSkillKey != undefined) {
            return "invoke skill only"
        }

        // if(unit.energy["move"] == true) {
        //     return "move only"
        // } else if(unit.energy["invoke skill"] == true) {
        //     return "invoke skill only"
        // }

        // if(unit.energy["move"] == false
        // && unit.energy["invoke skill"] == true) {
        //     return "invoke skill only"
        // } else if(unit.energy["move"] == true) {
        //     return "move only"
        // }

        if(unit.energy["move"] == false
        && unit.energy["invoke skill"] == true) {
            return "invoke skill only"
        } else if(unit.energy["move"] == true) {
            return "move and invoke skill"
        }

        return "none"
    }
    isSelectedSkill(skillKey, unit) {
        if(skillKey != undefined) {
            if(this.activeSkillKey != undefined) {
                return skillKey == this.activeSkillKey
            } else {
                return skillKey == unit.equippedSkills["attack1"]
                    || skillKey == unit.equippedSkills["support1"]
            }
        }
    }
    // the difference between findActionInActionlistToActuallyUse and
    // findActionInActionlist is one is static and doesn't bother itself
    // with the currently selected unit, previous hover positions, etc.
    static findActionInActionlistToActuallyUse({unit, actionlist, options = {}}) {
        const mode = options.mode || "none"

        let subactionlist = actionlist.filter((action) => {
            if(action.type == "invoke skill") {
                // // TODO: You should also check if this is
                // // a player unit and that the unit has
                // // this skill and is selected.
                // if(this.activeSkillKey != undefined
                // && options.ignoreActiveSkill != true) {
                //     if(action.skillKey != this.activeSkillKey) {
                //         return false
                //     }
                // } else {
                //     if(action.targetAffiliation != unit.affiliation
                //     && action.skillKey != unit.equippedSkills["attack1"]) {
                //         return false
                //     }
                //     if(action.targetAffiliation == unit.affiliation
                //     && action.skillKey != unit.equippedSkills["support1"]) {
                //         return false
                //     }
                // }
            }
            if(mode == "invoke skill only") {
                return action.type == "invoke skill"
                    && Geometry.equals(action.positions[1], unit.position)
            }
            if(mode == "move only") {
                return action.type == "move"
                    || action.type == "wait-for-move"
                    || action.type == "wait-for-attack"
            }
            if(mode == "move and invoke skill") {
                return true
            }
        })

        subactionlist.forEach((action) => {
            action.recentlyHoveredScore = Infinity
            if(action.type == "move through"
            || action.type == "no move") {
                return action
            }
            if(action.positions != undefined
            && action.positions.length > 1) {
                // for(let index in this.previousPositions) {
                //     let previousPosition = this.previousPositions[index]
                //     if(Geometry.equals({"x": previousPosition.x, "y": previousPosition.y}, {"x": action.positions[1].x, "y": action.positions[1].y})) { // IGNORING THE Z AXIS
                //     // if(Geometry.equals(previousPosition, action.positions[1])) {
                //         action.recentlyHoveredScore = index
                //         return action
                //     }
                // }
            }
            // if(action.type == "move") {
            //     action.recentlyHoveredScore = -10
            // }
        })
        subactionlist.sort((a, b) => {
            if(a.recentlyHoveredScore < b.recentlyHoveredScore) return -1
            if(a.recentlyHoveredScore > b.recentlyHoveredScore) return +1
            if(a.distance < b.distance) return -1
            if(a.distance > b.distance) return +1
            return 0
        })
        const moveActionlist = subactionlist.filter((action) => {
            return action.type == "move"
                || action.type == "wait-for-move"
                || action.type == "wait-for-attack"
        })
        if(moveActionlist[0] != undefined) {
            return moveActionlist[0]
        }
        if(subactionlist[0] != undefined) {
            return subactionlist[0]
        }
    }
    findActionInActionlist({unit, actionlist, options = {}}) {
        const mode = options.mode || this.mode(unit)

        let subactionlist = actionlist.filter((action) => {
            if(action.type == "invoke skill") {
                // TODO: You should also check if this is
                // a player unit and that the unit has
                // this skill and is selected.
                if(this.activeSkillKey != undefined
                && options.ignoreActiveSkill != true) {
                    if(action.skillKey != this.activeSkillKey) {
                        return false
                    }
                } else {
                    return true
                    // if(action.targetAffiliation != unit.affiliation
                    // && action.skillKey != unit.equippedSkills["attack1"]) {
                    //     return false
                    // }
                    // if(action.targetAffiliation == unit.affiliation
                    // && action.skillKey != unit.equippedSkills["support1"]) {
                    //     return false
                    // }
                }
            }
            if(mode == "invoke skill only") {
                return action.type == "invoke skill"
                    && Geometry.equals(action.positions[1], unit.position)
            }
            if(mode == "move only") {
                return action.type == "move"
                    || action.type == "wait-for-move"
                    || action.type == "wait-for-attack"
            }
            if(mode == "move and invoke skill") {
                return true
            }
        })

        subactionlist.forEach((action) => {
            action.recentlyHoveredScore = Infinity
            if(action.type == "move through"
            || action.type == "no move") {
                return action
            }
            if(action.positions != undefined
            && action.positions.length > 1) {
                for(let index in this.previousPositions) {
                    let previousPosition = this.previousPositions[index]
                    if(Geometry.equals({"x": previousPosition.x, "y": previousPosition.y}, {"x": action.positions[1].x, "y": action.positions[1].y})) { // IGNORING THE Z AXIS
                    // if(Geometry.equals(previousPosition, action.positions[1])) {
                        action.recentlyHoveredScore = index
                        return action
                    }
                }
            }
            // if(action.type == "move") {
            //     action.recentlyHoveredScore = -10
            // }
        })
        subactionlist.sort((a, b) => {
            if(a.recentlyHoveredScore < b.recentlyHoveredScore) return -1
            if(a.recentlyHoveredScore > b.recentlyHoveredScore) return +1
            if(a.distance < b.distance) return -1
            if(a.distance > b.distance) return +1
            return 0
        })

        const moveActionlist = subactionlist.filter((action) => {
            return action.type == "move"
                || action.type == "wait-for-move"
                || action.type == "wait-for-attack"
        })
        if(moveActionlist[0] != undefined) {
            return moveActionlist[0]
        }

        if(subactionlist[0] != undefined) {
            return subactionlist[0]
        }
    }
    findAction({unit, position}) {
        if(unit == undefined
        || unit.actionmap == undefined
        || unit.actionmap[position.x + "x" + position.y/* + "x" + position.z*/] == undefined
        || unit.actionmap[position.x + "x" + position.y/* + "x" + position.z*/] instanceof Array == false) {
            return
        }
        const actionlist = unit.actionmap[position.x + "x" + position.y/* + "x" + position.z*/]
        return this.findActionInActionlist({unit, actionlist})
    }
    isOnCamera(position) {
        const BUFFER = 2
        if(position.x < Math.floor(this.camera.position.x / sizes.grid.width) - BUFFER
        || position.x > Math.floor(this.camera.position.x / sizes.grid.width) + (sizes.frame.width) + BUFFER) {
            return false
        }
        return true
    }
}

class Action {
    static isNothing(action) {
        if(action.type == "no move"
        // || action.type == "wait"
        || action.type == "move through") {
            return true
        }
        const performer = action.alphastage.units[action.performerKey]
        if(action.type == "move"
        && performer.position.x == action.position.x
        && performer.position.y == action.position.y) {
        // && performer.position.z == action.position.z) {
            return true
        }
    }
}
